import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './Select.module.css';

/**
 * Select Component
 * Generic select/dropdown component for form inputs
 */
function Select({
  id,
  name,
  value,
  onChange,
  options,
  placeholder,
  disabled,
  className,
  ...rest
}) {
  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.value, e);
    }
  };

  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      className={`${styles.select} ${className || ''}`}
      {...rest}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option
          key={option.value}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
}

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Select.defaultProps = {
  id: undefined,
  name: undefined,
  value: '',
  onChange: undefined,
  placeholder: undefined,
  disabled: false,
  className: '',
};

export { Select };
export default Select;

